import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { FaChevronDown, FaChevronRight, FaBook } from "react-icons/fa";
import "../../assets/scss/Lesson.scss";
import { useFetchStrapiData } from "../../config/strapiService";
import { createSlug } from "../../config/utils";

const Sidebar = () => {
	const { quizData, error } = useFetchStrapiData();
	const location = useLocation();
	const [expandedUnits, setExpandedUnits] = useState({});
	const { subjectSlug, courseSlug, unitSlug } = useParams();

	useEffect(() => {
		if (quizData?.units) {
			const initialExpandedState = {};
			const currentUnit = quizData.units.find(
				(unit) => createSlug(unit.title) === unitSlug
			);
			if (currentUnit) {
				initialExpandedState[currentUnit.id] = true;
			} else {
				const firstUnit = quizData.units[0];
				if (firstUnit) {
					initialExpandedState[firstUnit.id] = true;
				}
			}
			setExpandedUnits(initialExpandedState);
		}
	}, [quizData, unitSlug]);

	if (error) {
		return (
			<div className="sidebar">Error loading course data: {error}</div>
		);
	}

	if (!quizData) {
		return <div className="sidebar">Loading...</div>;
	}

	const toggleUnit = (unitId) => {
		setExpandedUnits((prev) => ({
			...prev,
			[unitId]: !prev[unitId],
		}));
	};

	return (
		<div className="sidebar">
			<div className="sidebar__header">
				<h2 className="sidebar__title">
					<FaBook style={{ marginRight: "12px" }} />
					{quizData.course}
				</h2>
			</div>

			<div className="sidebar__content">
				<div className="sidebar__units">
					{quizData.units.map((unit) => (
						<div key={unit.id} className="sidebar__unit">
							<button
								className="sidebar__unit-button"
								onClick={() => toggleUnit(unit.id)}>
								<span className="sidebar__unit-icon">
									{expandedUnits[unit.id] ? (
										<FaChevronDown />
									) : (
										<FaChevronRight />
									)}
								</span>
								<h4 className="sidebar__unit-title">
									{unit.title}
								</h4>
							</button>

							{expandedUnits[unit.id] && (
								<div className="sidebar__lessons">
									{unit.lessons.map((lesson, index) => (
										<NavLink
											key={lesson.id}
											to={`/courses/${subjectSlug}/${courseSlug}/${createSlug(unit.title)}/${createSlug(lesson.title)}/${lesson.id}`}
											className={({ isActive }) =>
												`sidebar__lesson ${
													isActive ||
													location.pathname.includes(
														`/${lesson.id}`
													)
														? "sidebar__lesson--active"
														: ""
												}`
											}>
											<div className="sidebar__lesson-content">
												<span className="sidebar__lesson-title">
													{lesson.title}
												</span>
											</div>
										</NavLink>
									))}
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
